// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const LaborRateHistory = t.struct({
    averageTechPayRate: t.maybe(t.Number),
    days: t.maybe(t.Number),
    dealerAccount: t.maybe(t.String),
    dealerCity: t.maybe(t.String),
    dealerName: t.maybe(t.String),
    dealerState: t.maybe(t.String),
    decisionDate: t.maybe(t.Number),
    deereRemarks: t.maybe(t.String),
    effectiveDate: t.maybe(t.Number),
    laborType: t.maybe(t.String),
    laborTypeDescription: t.maybe(t.String),
    newLaborRate: t.maybe(t.Number),
    oldLaborRate: t.maybe(t.Number),
    processingStatus: t.maybe(t.String),
    reasonForChange: t.maybe(t.String),
    requestDate: t.maybe(t.Number),
    requestedBy: t.maybe(t.String),
    requestedByName: t.maybe(t.String)
}, {
    name: 'LaborRateHistory',
    strict: true
});

export const getDefaultState = () => new LaborRateHistory({});

export default LaborRateHistory;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/labor-rate-history.js